import { useEffect } from "react";
export default function CheckUnsavedChanges(props) {

    useEffect(() => {
        const handler = event => {
            event.preventDefault();
            event.returnValue = "";
        };

        if (props.unsavedChanges) {
            window.addEventListener("beforeunload", handler);
            // clean it up, if the dirty state changes
            return () => {
                window.removeEventListener("beforeunload", handler);
            };
        }
        // since this is not dirty, don't do anything
        return () => { };

    }, [props.unsavedChanges])


    return <></>
}